document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll(".recomendados-carousel");
  carousels.forEach((el) => {
    new Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 5,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      loop: true,

      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        768: { slidesPerView: 2.8 },
        1024: { slidesPerView: 4 },
      },
    });
  });
});
